<template>
  <v-bottom-navigation
    fixed
    dark
    :value="true"
    grow
    horizontal
  >
    <v-btn @click="language('en')">
      English
    </v-btn>
    <v-btn @click="language('es')">
      Español
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "LanguageSelect",
  methods: {
    language(lang) {
      this.$i18n.locale = lang;
    }
  }
};
</script>